"use client";

import { readFragment } from "@opensea/graphql";
import { bn } from "@opensea/utils";
import { useBalances } from "../../../../providers/BalancesProvider";
import { useSwapContext } from "../provider/SwapContext";
import { useSwapGasCheckFragment } from "./useSwapGasCheck.fragment";
export function useSwapGasCheck() {
  const {
    quote: quoteKey
  } = useSwapContext();
  const {
    balances
  } = useBalances();
  const swapRoutes = readFragment(useSwapGasCheckFragment, quoteKey);
  const route = swapRoutes?.swapRoutes[0];
  if (route?.__typename === "SwapRoute" && route.fromAsset.__typename === "Currency") {
    const gasCost = route.costs.find(c => c.costType === "GAS")?.cost;
    if (gasCost) {
      const gasSymbol = gasCost.token.symbol;
      const gasChainIdentifier = gasCost.token.chain.identifier;
      const fromAsset = route.fromAsset;
      const fromAssetAmount = bn(route.pricePerFromAsset.token.unit);
      const gasBalance = balances.find(b => b.currency.chainIdentifier === gasChainIdentifier && b.currency.symbol === gasSymbol);
      let gasBalanceAmount = bn(gasBalance?.quantity ?? 0);
      const gasCostAmount = bn(gasCost.token.unit);
      const fromAssetIsGasAsset = fromAsset.chainIdentifier === gasChainIdentifier && fromAsset.symbol === gasSymbol;
      if (fromAssetIsGasAsset) {
        gasBalanceAmount = gasBalanceAmount.minus(fromAssetAmount);
      }
      gasBalanceAmount = gasBalanceAmount.minus(gasCostAmount);
      if (gasBalanceAmount.lt(0)) {
        return {
          hasGas: false,
          gasSymbol
        };
      }
    }
  }
  return {
    hasGas: true
  };
}